import {
  FormHelperText,
  TextField as MUITextField,
  Typography
} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import InputLabel from "@material-ui/core/InputLabel";
import TableRow from "@material-ui/core/TableRow";
import { DatePicker } from "@material-ui/pickers";
import { useAddress } from "components/request-document/components/Address";
import {
  StyleCheckbox,
  StyledTableCell,
  useStyles
} from "components/request-document/components/Commons";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { selectMasterData } from "redux/modules/masterSlice";

const TextField = React.memo(MUITextField);

export default function PersonalIncomeHSPrivate({ formik }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const canEdit = useSelector(canEditForm);
  const addressFieldOptions = useAddress({ formik });

  const masterData = useSelector(selectMasterData);
  const nationalityConfig = get(masterData, "nationalityConfig", []);
  const sourceIncoms = get(masterData, "sourcesOfincomeConfig", []);

  useEffect(() => {
    const n1 =
      formik.values.document.NolessIncomeLastYearUSD !== ""
        ? parseFloat(formik.values.document.NolessIncomeLastYearUSD)
        : 0;
    const n2 =
      formik.values.document.NolessIncomeLast2YearUSD !== ""
        ? parseFloat(formik.values.document.NolessIncomeLast2YearUSD)
        : 0;
    const sum = n1 + n2;
    formik.setFieldValue("document.NolessIncomeCurrentYearUSD", sum);
    console.log(sum);
  }, [
    formik.values.document.NolessIncomeLastYearUSD,
    formik.values.document.NolessIncomeLast2YearUSD,
  ]);

  useEffect(() => {
    const n1 =
      formik.values.document.MorethanIncomeLastYearUSD !== ""
        ? parseFloat(formik.values.document.MorethanIncomeLastYearUSD)
        : 0;
    const n2 =
      formik.values.document.MorethanIncomeLast2YearUSD !== ""
        ? parseFloat(formik.values.document.MorethanIncomeLast2YearUSD)
        : 0;
    const sum = n1 + n2;
    formik.setFieldValue("document.MorethanIncomeCurrentYearUSD", sum);
  }, [
    formik.values.document.MorethanIncomeLastYearUSD,
    formik.values.document.MorethanIncomeLast2YearUSD,
  ]);

  return (
    <>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div>
              <Typography style={{ fontWeight: "bold" }}>
                Average personal income per year (Please select only one)
              </Typography>
              <FormControlLabel
                control={
                  <StyleCheckbox
                    disabled={!canEdit}
                    name="document.IncomeNolessHSPC"
                    checked={formik.values.document.IncomeNolessHSPC === "true"}
                    onClick={() => {
                      formik.setFieldValue(
                        "document.IncomeNolessHSPC",
                        formik.values.document.IncomeNolessHSPC === "true"
                          ? "false"
                          : "true"
                      );

                      formik.setFieldValue(
                        "document.IncomeMorethanHSPC",
                        "false"
                      );
                    }}
                  />
                }
                label={
                  <Typography style={{ fontWeight: "bold" }}>
                    {` Personal income no less than 80,000 USD/year in the past 2 years 
before applying for the visa `}
                  </Typography>
                }
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      {formik.values.document.IncomeNolessHSPC === "true" ? (
        <>
          <TableRow>
            <StyledTableCell colSpan={4}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Income in current year</InputLabel>
                </div>
              </div>
            </StyledTableCell>

            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Amount (USD)</InputLabel>
                </div>
              </div>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Last year (YYYY)</InputLabel>
                  <FormGroup row>
                    <DatePicker
                      // style={{ width: 200 }}
                      className={classes.formControl}
                      inputVariant="outlined"
                      disableFuture={false}
                      openTo="year"
                      format="YYYY"
                      label="Last year (YYYY) "
                      views={["year"]}
                      name={`document.NolessLastYear`}
                      value={
                        get(formik.values, `document.NolessLastYear`, null) ||
                        null
                      }
                      onChange={(date) => {
                        formik.setFieldValue(
                          `document.NolessLastYear`,
                          date.format("YYYY")
                        );
                      }}
                      error={isError(`document.NolessLastYear`, formik)}
                      helperText={getErrorMessage(
                        `document.NolessLastYear`,
                        formik
                      )}
                      disabled={!canEdit}
                    />
                  </FormGroup>
                </div>
              </div>
            </StyledTableCell>

            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <TextField
                    disabled={!canEdit}
                    variant="outlined"
                    className={classes.textField}
                    name="document.NolessIncomeLastYearUSD"
                    value={formik.values.document.NolessIncomeLastYearUSD}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("document.NolessIncomeLastYearUSD", formik)}
                    helperText={getErrorMessage(
                      "document.NolessIncomeLastYearUSD",
                      formik
                    )}
                    type="number"
                  />
                </div>
              </div>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Last 2nd year (YYYY)</InputLabel>
                  <FormGroup row>
                    <DatePicker
                      // style={{ width: 200 }}
                      className={classes.formControl}
                      inputVariant="outlined"
                      disableFuture={false}
                      openTo="year"
                      format="YYYY"
                      label="Start"
                      views={["year"]}
                      name={`document.NolessLast2Year`}
                      value={
                        get(formik.values, `document.NolessLast2Year`, null) ||
                        null
                      }
                      onChange={(date) => {
                        formik.setFieldValue(
                          `document.NolessLast2Year`,
                          date.format("YYYY")
                        );
                      }}
                      error={isError(`document.NolessLast2Year`, formik)}
                      helperText={getErrorMessage(
                        `document.NolessLast2Year`,
                        formik
                      )}
                      disabled={!canEdit}
                    />
                  </FormGroup>
                </div>
              </div>
            </StyledTableCell>

            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <TextField
                    disabled={!canEdit}
                    variant="outlined"
                    className={classes.textField}
                    name="document.NolessIncomeLast2YearUSD"
                    value={formik.values.document.NolessIncomeLast2YearUSD}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("document.NolessIncomeLast2YearUSD", formik)}
                    helperText={getErrorMessage(
                      "document.NolessIncomeLast2YearUSD",
                      formik
                    )}
                    type="number"
                  />
                </div>
              </div>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>
                    Total  income (as of the submission date)
                  </InputLabel>
                  <FormGroup row>
                    <DatePicker
                      // style={{ width: 200 }}
                      className={classes.formControl}
                      inputVariant="outlined"
                      disableFuture={false}
                      openTo="year"
                      format="DD-MM-YYYY"
                      label="Start"
                      views={["year", "month", "date"]}
                      name={`document.NolessCurrentYearIncome`}
                      value={
                        get(
                          formik.values,
                          `document.NolessCurrentYearIncome`,
                          null
                        ) || null
                      }
                      onChange={(date) => {
                        formik.setFieldValue(
                          `document.NolessCurrentYearIncome`,
                          date.format("YYYY-MM-DD")
                        );
                      }}
                      error={isError(
                        `document.NolessCurrentYearIncome`,
                        formik
                      )}
                      helperText={getErrorMessage(
                        `document.NolessCurrentYearIncome`,
                        formik
                      )}
                      disabled={!canEdit}
                    />
                    <DatePicker
                      // style={{ width: 200 }}
                      className={classes.formControl}
                      inputVariant="outlined"
                      disableFuture={false}
                      openTo="year"
                      format="DD-MM-YYYY"
                      label="End"
                      views={["year", "month", "date"]}
                      name={`document.NolessCurrentYearIncomeEnd`}
                      value={
                        get(
                          formik.values,
                          `document.NolessCurrentYearIncomeEnd`,
                          null
                        ) || null
                      }
                      onChange={(date) => {
                        formik.setFieldValue(
                          `document.NolessCurrentYearIncomeEnd`,
                          date.format("YYYY-MM-DD")
                        );
                      }}
                      error={isError(
                        `document.NolessCurrentYearIncomeEnd`,
                        formik
                      )}
                      helperText={getErrorMessage(
                        `document.NolessCurrentYearIncomeEnd`,
                        formik
                      )}
                      disabled={!canEdit}
                    />
                  </FormGroup>
                </div>
              </div>
            </StyledTableCell>

            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <TextField
                    disabled={!canEdit}
                    variant="outlined"
                    className={classes.textField}
                    name="document.NolessIncomeCurrentYearUSD"
                    value={formik.values.document.NolessIncomeCurrentYearUSD}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    inputProps={{ readOnly: true }}
                    error={isError(
                      "document.NolessIncomeCurrentYearUSD",
                      formik
                    )}
                    helperText={getErrorMessage(
                      "document.NolessIncomeCurrentYearUSD",
                      formik
                    )}
                    type="number"
                  />
                </div>
              </div>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Sources of income</InputLabel>
                  <FormGroup row>
                    {sourceIncoms.map((x) => (
                      <>
                        {x.sourcesOfincomeID !== "O" ? (
                          <FormControlLabel
                            control={
                              <StyleCheckbox
                                disabled={!canEdit}
                                name="document.NolessHSPCsourcesOfincomeID"
                                checked={formik.values.document.NolessHSPCsourcesOfincomeID.split(
                                  ","
                                ).some((xs) => xs === x.sourcesOfincomeID)}
                                onClick={() => {
                                  const arr =
                                    formik.values.document.NolessHSPCsourcesOfincomeID.split(
                                      ","
                                    );
                                  const value = arr.find(
                                    (xs) => xs === x.sourcesOfincomeID
                                  )
                                    ? arr.filter(
                                      (xs) => xs !== x.sourcesOfincomeID
                                    )
                                    : [...arr, x.sourcesOfincomeID];
                                  formik.setFieldValue(
                                    "document.NolessHSPCsourcesOfincomeID",
                                    value.join(",")
                                  );
                                }}
                              />
                            }
                            label={x.sourcesOfincomeName}
                          />
                        ) : null}
                      </>
                    ))}
                  </FormGroup>
                  {sourceIncoms.map((x) => (
                    <>
                      {x.sourcesOfincomeID === "O" ? (
                        <>
                          <FormControlLabel
                            control={
                              <StyleCheckbox
                                disabled={!canEdit}
                                name="document.NolessHSPCsourcesOfincomeID"
                                checked={
                                  formik.values.document.NolessHSPCsourcesOfincomeID.split(
                                    ","
                                  ).some((xs) => xs === x.sourcesOfincomeID)
                                  // formik.values.document.sourcesOfincomeID ===
                                  // x.sourcesOfincomeID
                                }
                                onClick={() => {
                                  const arr =
                                    formik.values.document.NolessHSPCsourcesOfincomeID.split(
                                      ","
                                    );
                                  const value = arr.find(
                                    (xs) => xs === x.sourcesOfincomeID
                                  )
                                    ? arr.filter(
                                      (xs) => xs !== x.sourcesOfincomeID
                                    )
                                    : [...arr, x.sourcesOfincomeID];
                                  formik.setFieldValue(
                                    "document.NolessHSPCsourcesOfincomeID",
                                    value.join(",")
                                  );
                                }}
                              />
                            }
                            label={x.sourcesOfincomeName}
                          />
                          <TextField
                            variant="outlined"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            name="document.NolessHSPCsourcesOfincomeOther"
                            value={
                              formik.values.document
                                .NolessHSPCsourcesOfincomeOther
                            }
                          />
                        </>
                      ) : null}
                    </>
                  ))}
                  <FormHelperText
                    error={isError(
                      "document.NolessHSPCsourcesOfincomeID",
                      formik
                    )}
                  >
                    {getErrorMessage(
                      "document.NolessHSPCsourcesOfincomeID",
                      formik
                    )}
                  </FormHelperText>
                </div>
              </div>
            </StyledTableCell>
          </TableRow>
        </>
      ) : null}

      {/* End Section 1 */}

      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div>
              <FormControlLabel
                control={
                  <StyleCheckbox
                    disabled={!canEdit}
                    name="document.IncomeMorethanHSPC"
                    checked={
                      formik.values.document.IncomeMorethanHSPC === "true"
                    }
                    onClick={() => {
                      formik.setFieldValue(
                        "document.IncomeMorethanHSPC",
                        formik.values.document.IncomeMorethanHSPC === "true"
                          ? "false"
                          : "true"
                      );
                      formik.setFieldValue(
                        "document.IncomeNolessHSPC",
                        "false"
                      );
                    }}
                  />
                }
                label={
                  <Typography style={{ fontWeight: "bold" }}>
                    {` Personal income >= 40,000 USD/year in the past 2 years`}
                  </Typography>
                }
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      {formik.values.document.IncomeMorethanHSPC === "true" ? (
        <>
          <TableRow>
            <StyledTableCell colSpan={4}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Income in current year</InputLabel>
                </div>
              </div>
            </StyledTableCell>

            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Amount (USD)</InputLabel>
                </div>
              </div>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Last year (YYYY)</InputLabel>
                  <FormGroup row>
                    <DatePicker
                      // style={{ width: 200 }}
                      className={classes.formControl}
                      inputVariant="outlined"
                      disableFuture={false}
                      openTo="year"
                      format="YYYY"
                      label="Last year (YYYY) "
                      views={["year"]}
                      name={`document.MorethanLastYear`}
                      value={
                        get(formik.values, `document.MorethanLastYear`, null) ||
                        null
                      }
                      onChange={(date) => {
                        formik.setFieldValue(
                          `document.MorethanLastYear`,
                          date.format("YYYY")
                        );
                      }}
                      error={isError(`document.MorethanLastYear`, formik)}
                      helperText={getErrorMessage(
                        `document.MorethanLastYear`,
                        formik
                      )}
                      disabled={!canEdit}
                    />
                  </FormGroup>
                </div>
              </div>
            </StyledTableCell>

            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <TextField
                    disabled={!canEdit}
                    variant="outlined"
                    className={classes.textField}
                    name="document.MorethanIncomeLastYearUSD"
                    value={formik.values.document.MorethanIncomeLastYearUSD}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError(
                      "document.MorethanIncomeLastYearUSD",
                      formik
                    )}
                    helperText={getErrorMessage(
                      "document.MorethanIncomeLastYearUSD",
                      formik
                    )}
                    type="number"
                  />
                </div>
              </div>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Last 2nd year (YYYY)</InputLabel>
                  <FormGroup row>
                    <DatePicker
                      // style={{ width: 200 }}
                      className={classes.formControl}
                      inputVariant="outlined"
                      disableFuture={false}
                      openTo="year"
                      format="YYYY"
                      label="Start"
                      views={["year"]}
                      name={`document.MorethanLast2Year`}
                      value={
                        get(
                          formik.values,
                          `document.MorethanLast2Year`,
                          null
                        ) || null
                      }
                      onChange={(date) => {
                        formik.setFieldValue(
                          `document.MorethanLast2Year`,
                          date.format("YYYY")
                        );
                      }}
                      error={isError(`document.MorethanLast2Year`, formik)}
                      helperText={getErrorMessage(
                        `document.MorethanLast2Year`,
                        formik
                      )}
                      disabled={!canEdit}
                    />
                  </FormGroup>
                </div>
              </div>
            </StyledTableCell>

            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <TextField
                    disabled={!canEdit}
                    variant="outlined"
                    className={classes.textField}
                    name="document.MorethanIncomeLast2YearUSD"
                    value={formik.values.document.MorethanIncomeLast2YearUSD}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError(
                      "document.MorethanIncomeLast2YearUSD",
                      formik
                    )}
                    helperText={getErrorMessage(
                      "document.MorethanIncomeLast2YearUSD",
                      formik
                    )}
                    type="number"
                  />
                </div>
              </div>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>
                    Total  income (as of the submission date)
                  </InputLabel>
                  <DatePicker
                    // style={{ width: 200 }}
                    className={classes.formControl}
                    inputVariant="outlined"
                    disableFuture={false}
                    openTo="year"
                    format="DD-MM-YYYY"
                    label="Start"
                    views={["year", "month", "date"]}
                    name={`document.MorethanCurrentYearIncome`}
                    value={
                      get(
                        formik.values,
                        `document.MorethanCurrentYearIncome`,
                        null
                      ) || null
                    }
                    onChange={(date) => {
                      formik.setFieldValue(
                        `document.MorethanCurrentYearIncome`,
                        date.format("YYYY-MM-DD")
                      );
                    }}
                    error={isError(
                      `document.MorethanCurrentYearIncome`,
                      formik
                    )}
                    helperText={getErrorMessage(
                      `document.MorethanCurrentYearIncome`,
                      formik
                    )}
                    disabled={!canEdit}
                  />
                  <DatePicker
                    // style={{ width: 200 }}
                    className={classes.formControl}
                    inputVariant="outlined"
                    disableFuture={false}
                    openTo="year"
                    format="DD-MM-YYYY"
                    label="End"
                    views={["year", "month", "date"]}
                    name={`document.MorethanCurrentYearIncomeEnd`}
                    value={
                      get(
                        formik.values,
                        `document.MorethanCurrentYearIncomeEnd`,
                        null
                      ) || null
                    }
                    onChange={(date) => {
                      formik.setFieldValue(
                        `document.MorethanCurrentYearIncomeEnd`,
                        date.format("YYYY-MM-DD")
                      );
                    }}
                    error={isError(
                      `document.MorethanCurrentYearIncomeEnd`,
                      formik
                    )}
                    helperText={getErrorMessage(
                      `document.MorethanCurrentYearIncomeEnd`,
                      formik
                    )}
                    disabled={!canEdit}
                  />
                </div>
              </div>
            </StyledTableCell>

            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <TextField
                    disabled={!canEdit}
                    variant="outlined"
                    className={classes.textField}
                    name="document.MorethanIncomeCurrentYearUSD"
                    value={formik.values.document.MorethanIncomeCurrentYearUSD}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    inputProps={{ readOnly: true }}
                    error={isError(
                      "document.MorethanIncomeCurrentYearUSD",
                      formik
                    )}
                    helperText={getErrorMessage(
                      "document.MorethanIncomeCurrentYearUSD",
                      formik
                    )}
                    type="number"
                  />
                </div>
              </div>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Sources of income</InputLabel>
                  <FormGroup row>
                    {sourceIncoms.map((x) => (
                      <>
                        {x.sourcesOfincomeID !== "O" ? (
                          <FormControlLabel
                            control={
                              <StyleCheckbox
                                disabled={!canEdit}
                                name="document.MorethanHSPCsourcesOfincomeID"
                                checked={formik.values.document.MorethanHSPCsourcesOfincomeID.split(
                                  ","
                                ).some((xs) => xs === x.sourcesOfincomeID)}
                                onClick={() => {
                                  const arr =
                                    formik.values.document.MorethanHSPCsourcesOfincomeID.split(
                                      ","
                                    );
                                  const value = arr.find(
                                    (xs) => xs === x.sourcesOfincomeID
                                  )
                                    ? arr.filter(
                                      (xs) => xs !== x.sourcesOfincomeID
                                    )
                                    : [...arr, x.sourcesOfincomeID];
                                  formik.setFieldValue(
                                    "document.MorethanHSPCsourcesOfincomeID",
                                    value.join(",")
                                  );
                                }}
                              />
                            }
                            label={x.sourcesOfincomeName}
                          />
                        ) : null}
                      </>
                    ))}
                  </FormGroup>
                  {sourceIncoms.map((x) => (
                    <>
                      {x.sourcesOfincomeID === "O" ? (
                        <>
                          <FormControlLabel
                            control={
                              <StyleCheckbox
                                disabled={!canEdit}
                                name="document.MorethanHSPCsourcesOfincomeID"
                                checked={
                                  formik.values.document.MorethanHSPCsourcesOfincomeID.split(
                                    ","
                                  ).some((xs) => xs === x.sourcesOfincomeID)
                                  // formik.values.document.sourcesOfincomeID ===
                                  // x.sourcesOfincomeID
                                }
                                onClick={() => {
                                  const arr =
                                    formik.values.document.MorethanHSPCsourcesOfincomeID.split(
                                      ","
                                    );
                                  const value = arr.find(
                                    (xs) => xs === x.sourcesOfincomeID
                                  )
                                    ? arr.filter(
                                      (xs) => xs !== x.sourcesOfincomeID
                                    )
                                    : [...arr, x.sourcesOfincomeID];
                                  formik.setFieldValue(
                                    "document.MorethanHSPCsourcesOfincomeID",
                                    value.join(",")
                                  );
                                }}
                              />
                            }
                            label={x.sourcesOfincomeName}
                          />
                          <TextField
                            variant="outlined"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            name="document.MorethanHSPCsourcesOfincomeOther"
                            value={
                              formik.values.document
                                .MorethanHSPCsourcesOfincomeOther
                            }
                          />
                        </>
                      ) : null}
                    </>
                  ))}
                  <FormHelperText
                    error={isError(
                      "document.MorethanHSPCsourcesOfincomeID",
                      formik
                    )}
                  >
                    {getErrorMessage(
                      "document.MorethanHSPCsourcesOfincomeID",
                      formik
                    )}
                  </FormHelperText>
                </div>
              </div>
            </StyledTableCell>
          </TableRow>
        </>
      ) : null}
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div>
              <Typography style={{ fontWeight: "bold" }}>
                {` The applicant must have one of the followings qualifications:`}
              </Typography>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div>
              <FormControlLabel
                control={
                  <StyleCheckbox
                    disabled={!canEdit}
                    name="document.PersonalGovernmentBond"
                    checked={
                      formik.values.document.PersonalGovernmentBond === "true"
                    }
                    onClick={() => {
                      formik.setFieldValue(
                        "document.PersonalGovernmentBond",
                        formik.values.document.PersonalGovernmentBond === "true"
                          ? "false"
                          : "true"
                      );
                    }}
                  />
                }
                label={
                  <Typography>
                    {` Obtaining a master's degree or above in science and technology  `}
                  </Typography>
                }
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div>
              <FormControlLabel
                control={
                  <StyleCheckbox
                    disabled={!canEdit}
                    name="document.PersonalDirectInvestment"
                    checked={
                      formik.values.document.PersonalDirectInvestment === "true"
                    }
                    onClick={() => {
                      formik.setFieldValue(
                        "document.PersonalDirectInvestment",
                        formik.values.document.PersonalDirectInvestment ===
                          "true"
                          ? "false"
                          : "true"
                      );
                    }}
                  />
                }
                label={
                  <Typography>
                    {` High-skilled with expertise relevant to the job   `}
                  </Typography>
                }
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div>
              <FormControlLabel
                control={
                  <StyleCheckbox
                    disabled={!canEdit}
                    name="document.PersonalRealEstate"
                    checked={
                      formik.values.document.PersonalRealEstate === "true"
                    }
                    onClick={() => {
                      formik.setFieldValue(
                        "document.PersonalRealEstate",
                        formik.values.document.PersonalRealEstate === "true"
                          ? "false"
                          : "true"
                      );
                    }}
                  />
                }
                label={<Typography>{` Retiree with expertise in science and technology    `}</Typography>}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  );
}
